module.exports = __webpack_public_path__ + "img/marine.9b764e4d.png";